var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCritIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.993 0C5.37009 0 0 4.38401 0 9.79076V24H3.99062V9.75054C3.99062 6.14221 7.57302 3.21187 12 3.21187C16.4199 3.21187 20.0094 6.13646 20.0094 9.75054V23.9943H24V9.79076C23.9859 4.38401 18.6158 0 11.993 0Z",
    fill: "#7033B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6094 23.9943H6.37653V9.64712C6.37653 7.11324 8.88914 5.06201 11.9929 5.06201C15.0968 5.06201 17.6094 7.11324 17.6094 9.64712V23.9943Z",
    fill: "#7033B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritIcon);
export default __webpack_public_path__ + "static/media/CritIcon.a57882dc711b1137ba37457c246cca12.svg";
export { ForwardRef as ReactComponent };